module.exports = __webpack_public_path__ + "img/reg.7328b6c6.jpg";